import { SharedConfigStoreState } from './types';

type SharedConfig = NonNullable<SharedConfigStoreState['config']>;

export const sharedConfigStoreSelector = {
  freeTrial: (
    state: SharedConfigStoreState
  ): SharedConfig['freeTrial'] | undefined => state.config?.freeTrial,
  creditLimits: (
    state: SharedConfigStoreState
  ): SharedConfig['creditLimits'] | undefined => state.config?.creditLimits,
  actions: (state: SharedConfigStoreState): SharedConfigStoreState['actions'] =>
    state.actions,
  config: (state: SharedConfigStoreState): SharedConfigStoreState['config'] =>
    state.config,
};
